import {
  CurrentOfferCost, NewOfferCost, Savings, TerminationFees,
} from '../types';

export default function computeSavings(terminationFees?: TerminationFees, currentOfferCost?: CurrentOfferCost, newOfferCost?: NewOfferCost): Savings | undefined {
  if (terminationFees === undefined || currentOfferCost === undefined || newOfferCost === undefined) return undefined;
  const currentOffer = currentOfferCost.total;
  const newOffer = newOfferCost.total;
  const terminationCost = (terminationFees.amountAfterReimbursement ?? terminationFees.amountToPay);
  return {
    result: currentOffer - newOffer - terminationCost,
  };
}
